import { Component, Input, OnInit, Output,EventEmitter, Injector } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { EmployeeData } from '../../../../@core/interfaces/masters/employee';
import { Subject } from 'rxjs';
import { QcReasonMstData } from '../../../../pages/inventory/backend-module/interface/master/qcreason-mst';
import { environment } from '../../../../../environments/environment';
import { RehabImpMarketsMstData } from '../../../../@core/interfaces/masters/rehab-imp-markets-mst';
import { DateService } from '../service/date.service';
import { takeUntil } from 'rxjs/operators';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { ReferralQueueComponent } from '../../../../pages/Masters/referral-queue/referral-queue.component';
import { access } from '../../../../data/access-constants';


@Component({
  selector: 'ngx-counselling',
  templateUrl: './counselling.component.html',
  styleUrls: ['./counselling.component.scss']
})
export class CounsellingComponent implements OnInit {

  @Output() dataEvent: EventEmitter<any[]> = new EventEmitter<any[]>();

  submitButtonTitle = "Add Counselling";
  isSubmitted = false;

  isAddmsg: boolean = false;
  isEditmsg: boolean = false;
  errormsg: boolean = false;

  allAPIDatas: any[] = [];

  editData: any = {};

  isAdd = true;
  isEdit = false;

  allCounsellings: any[] = [];

  @Input() regId: any;
  @Input() visitId: any;
  @Input() admissionId!: any;
  @Input() couselList!: any;
  @Input() visitDoctorid:string;
   @Input() rootId;
     pageTaskIds: Array<any> = []
  userAccessData: Array<any> = []

  empData: any[] = [];
  max = this.dateService.currentDate();
  minEndDate: Date = null;
  isCounsellingCreate:boolean=true;
    isCounsellingUpdate:boolean=true;

  phlen:number=4000;
  phcharflag:boolean=false;
  valuefield:string=''
  protected readonly unsubscribe$ = new Subject<void>();
  private tenandId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private userId = localStorage.getItem("userId");
  durationList: Array<any> = [{ id: 1, display: "10 Minutes", value: 10, type: "minutes" }, { id: 2, display: "20 Minutes", value: 20, type: "minutes" },
  { id: 3, display: "30 Minutes", value: 30, type: "minutes" }, { id: 4, display: "40 Minutes", value: 40, type: "minutes" }, { id: 5, display: "1 Hour", value: 1, type: "hour" }
    , { id: 6, display: "2 Hours", value: 2, type: "hour" }, { id: 7, display: "Select Manual", value: 0, type: "manual" }];

  counsellingForm: FormGroup;
  baseurl = environment.apiUrl + "/PatientCareTaskMaster";
  @Input() performNurseList:Array<any>=[];
  @Input() performDocList: Array<any> = [];
  @Input() showCounsellFields: Boolean

  counsellingTypes: any[];
  remarksCharChangeFlag: boolean = false;
  remarksCharLength: number = 100;
  currentDate: Date = new Date();
  callStatusList: Array<any> = [];
  patientFinalStatusList: Array<any> = [];
  counsellingStatusList: Array<any> = [];
  patientStatusUpdateFormSubmitted: boolean = false;
  constructor(private injector: Injector,private dateService: DateService, private fb: FormBuilder, protected employeeSrvc: EmployeeData, protected QcReasonMstData: QcReasonMstData, protected therapyMstSrvc: RehabImpMarketsMstData,protected rolesService: RolesData) {
    this.counsellingForm = this.fb.group({
      counsellingId: this.fb.control('', [Validators.required]),
      counsellorId: this.fb.control('', [Validators.required]),
      durationId: this.fb.control('', [Validators.required]),
      date: this.fb.control('', [Validators.required]),
      endDate: this.fb.control('', [Validators.required]),
      notes: this.fb.control('', [Validators.required]),
      performDoc:this.fb.control(null),
      performNurse:this.fb.control(null),
      remarks: this.fb.control(null),
      counsellingDate: this.fb.control(null),
      patientFinalStatus: this.fb.control(null),
      patientCallStatus: this.fb.control(null),
      careTaskStatus:this.fb.control(null),

    });
    this.counsellingForm.get('date').valueChanges.subscribe(fromDate => {
      const endDate = this.counsellingForm.get('endDate');

      if (fromDate) {
        endDate.setValue(null);
        this.minEndDate = fromDate;
      }
    });
  }
  callCategoryAPI() {
    const masterTypes = {
      masterTypes: ["CALL_STATUS","COUNSELLING_TYPE"]
    }
    if (this.callStatusList?.length == 0) {
      this.rolesService.create(`${environment.apiUrl}/tenants/${this.tenandId}/masterreason/${this.branchId}/getMultipleTenantBasedMasters`, masterTypes).pipe(takeUntil(this.unsubscribe$)).subscribe((responseData: any) => {
        const response = responseData.details;
        this.callStatusList = response.filter(each => each.mrType === 'CALL_STATUS' && each.isActive == true);
        this.counsellingTypes = response.filter(each => each.mrType === 'COUNSELLING_TYPE' && each.isActive == true);
      })
    }
  }

  fetchPatientCareFinalStatus() {
    if (this.patientFinalStatusList.length == 0) {

      this.employeeSrvc.list("PatientCareTaskMaster/getPatientCareFinalStatus").pipe(takeUntil(this.unsubscribe$)).subscribe((returnData: any) => {
        this.patientFinalStatusList = returnData.details;
      }, (error) => {

      }, () => {
      });


    }

  }
  fetchCounsellingStatus() {
    if (this.counsellingStatusList.length == 0) {
      this.employeeSrvc.list("PatientCareTaskMaster/getCounsellingStatus").pipe(takeUntil(this.unsubscribe$)).subscribe((returnData: any) => {
        this.counsellingStatusList = returnData.details;
      }, (error) => {

      }, () => {
      });


    }

  }
 get apiUrl(): string {
    return environment.apiUrl;
  }
  fetchPageAccess() {
    this.pageTaskIds = [];
    this.pageTaskIds.push(
       access.task.TASKORDERCOUNSELLING
      
    );
    let matrixSearchData = {
      taskId: this.pageTaskIds,
      UserId: localStorage.getItem("userType")
    }
    this.rolesService.create(`${this.apiUrl}/userrole/${this.tenandId}/${this.branchId}/pageaccesssearch`, matrixSearchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.userAccessData = data;
    }, (error) => {
    }, () => {
      
      // BOOK ADMISSION ACCESS
    let counsellingCreate = this.userAccessData.some(element => access.task.TASKORDERCOUNSELLING == element.taskID && element.actionID == access.action.CREATE && element.permission == "true");
    this.isCounsellingCreate=counsellingCreate;
   let counsellingUpdate = this.userAccessData.some(element => access.task.TASKORDERCOUNSELLING == element.taskID && element.actionID == access.action.EDIT && element.permission == "true");
    this.isCounsellingUpdate=counsellingUpdate;

    });

  }
  remarksValueChange(value) {
    
    const val = (value?.target as HTMLTextAreaElement)?.value;
    if (val != null)
      this.remarksCharLength = 100 - val?.length;
  }

  onClickDuration(value) {
    if (value.id != 7) {
      this.counsellingForm.controls['durationId'].setValue(value.id);
      let getMinutes = this.durationList.filter(e => e.id == value.id);
      this.counsellingForm.controls['endDate'].setValue(this.addMinutesToDate(this.counsellingForm.get('date').value, getMinutes[0]));
    } else {
      this.counsellingForm.controls['durationId'].setValue(value.id);

    }
  }

  addMinutesToDate(date: Date, durationData: any): Date {
    let newDate = new Date(date);
    if (durationData.type == "minutes") {
      newDate.setMinutes(newDate.getMinutes() + durationData.value);

    } else if (durationData.type == "hour") {
      newDate.setHours(newDate.getHours() + durationData.value);
    }
    return newDate;
  }

  findCounsellingName(inputId: number) {
    return this.counsellingTypes.find((item) => item.mrId == inputId)?.reasonName;
  }

  findCounsellorName(inputId: any) {
    return this.empData.find((item) => item.id == inputId)?.firstName;
  }

  findDurationValue(inputId: any) {
    return this.durationList.find((item) => item.id == inputId)?.display;
  }




  get fval(): { [key: string]: AbstractControl } { return this.counsellingForm.controls; }

  ngOnInit(): void {

    this.fetchEmployeeforBranch();

    this.getCounsellings();
    this.fetchPageAccess();
    this.counsellingForm.controls['date'].setValue(this.max);  
    this.performDoc();
    this.performNurse();
    if(localStorage.getItem('jobCategoryId')=='2'){
      this.counsellingForm?.get('performNurse')?.setValue(localStorage.getItem('employeeId'));
    }
    if(localStorage.getItem('userFlag')=='Physician'){
      this.counsellingForm?.get('performDoc')?.setValue(localStorage.getItem('physicianId'));
    }
    else{
   this.counsellingForm.get('performDoc').setValue(this.visitDoctorid); }
    this.callCategoryAPI();
    this.fetchPatientCareFinalStatus();
    this.fetchCounsellingStatus();
this.counsellingForm.get('careTaskStatus').setValue(4); 
      
  }

  getCounsellings() {
    this.allAPIDatas = this.couselList;
    this.allCounsellings = this.couselList;
  }



  fetchEmployeeforBranch(): void {
    this.employeeSrvc.list(`tenants/${this.tenandId}/${this.branchId}/employee/all`).subscribe((data: any) => {
      this.empData = data.value;
    });


  }

  addCounselling(event) {
    event.target.disabled = true;

    this.isSubmitted = true;

    if (this.counsellingForm.valid) {

      const updatedFormValue = {
        ...this.counsellingForm.value,
        counsellingName: this.findCounsellingName( this.counsellingForm.get('counsellingId')?.value ), 
        counsellorName:this.findCounsellorName( this.counsellingForm.get('counsellorId')?.value ) ,
        duration:this.findDurationValue( this.counsellingForm.get('durationId')?.value ) 
      };

      if (this.isAdd) {
        let postData = {
          "woId": null,
          "regId": this.regId,
          "ipId": null,
          "careTaskType": 11,
          "careTaskPlace": null,
          "careTaskStatus": this.showCounsellFields ? this.counsellingForm.get('careTaskStatus').value: 4,
          "CreatedDate": new Date(),
          "CreatedBy": parseInt(this.userId),
          "UpdatedDate": null,
          "UpdatedBy": null,
          "TenantId": this.tenandId,
          "BranchId": this.branchId,
          "CreatedIP": null,
          "UpdatedIP": null,
          "inputJson": JSON.stringify(updatedFormValue),
          "visitId": this.visitId,
          "SubstatusName": 'Counselling',
          "patientCallStatus": this.counsellingForm.get('patientCallStatus').value,
          "patientFinalStatus": this.counsellingForm.get('patientFinalStatus').value,
          "remarks": this.counsellingForm.get('remarks').value,
          "doneDateTime": this.counsellingForm.get('counsellingDate').value,
          "rootId":this.rootId ? this.rootId:null
        }

        this.QcReasonMstData.create(this.baseurl + "/PostPatientCareTaskMst", postData).subscribe(
          (response) => {
            this.dataEvent.emit( response.details );
            this.reset();
                  const dashboardInstance = this.injector.get(ReferralQueueComponent);
                  dashboardInstance?.closeCounselPopup();
          },
          (err) => {
            event.target.disabled = false;
            this.errormsg = true;
            setTimeout(() => {
              this.errormsg = false;
            }, 4000)
          },
          () => {
            event.target.disabled = false;
            this.isAddmsg = true;
            this.phlen=4000;
            this.phcharflag=false;
            setTimeout(() => {
              this.isAddmsg = false;
            }, 4000)
          }
        );
      }
      else {
        let postData = {


          "pcId": this.editData?.pcId,
          "woId": null,
          "regId": this.regId,
          "ipId": null,
          "careTaskType": 11,
          "careTaskPlace": null,
          "careTaskStatus": 4,
          "CreatedDate": this.editData?.createdDate,
          "CreatedBy": parseInt(this.userId),
          "UpdatedDate": new Date(),
          "UpdatedBy": parseInt(this.userId),
          "TenantId": this.tenandId,
          "BranchId": this.branchId,
          "CreatedIP": null,
          "UpdatedIP": null,
          "inputJson": JSON.stringify(updatedFormValue),
          "visitId": this.visitId,
          "SubstatusName": 'Counselling',
          "patientCallStatus": this.counsellingForm.get('patientCallStatus').value,
          "patientFinalStatus": this.counsellingForm.get('patientFinalStatus').value,
          "remarks": this.counsellingForm.get('remarks').value,
          "doneDateTime": this.counsellingForm.get('counsellingDate').value,
        }

        this.QcReasonMstData.update(this.baseurl + "/UpdatePatientCareTaskMst/" + this.editData?.pcId, postData).subscribe(
          (response) => {
            this.dataEvent.emit( response.details );
            this.reset();
            this.isEdit = false;
            this.isAdd = true;
            this.submitButtonTitle = "Add Counselling"
             const dashboardInstance = this.injector.get(ReferralQueueComponent);
                dashboardInstance?.closeCounselPopup();
          },
          (err) => {
            event.target.disabled = false;
            this.errormsg = true;
            setTimeout(() => {
              this.errormsg = false;
            }, 4000)
          },
          () => {
            event.target.disabled = false;
            this.isEditmsg = true;
            this.phlen=4000;
            this.phcharflag=false;
            setTimeout(() => {
              this.isEditmsg = false;
            }, 4000)
          }

        );


      }
    }
    else{
      event.target.disabled = false;
      this.errormsg = true;
            setTimeout(() => {
              this.errormsg = false;
            }, 4000)
    }
  }

  editCounselling(index: number, data: any) {
    if(!!data?.performNurse){this.performNurse();}
    if(!!data?.performDoc){this.performDoc();}
    this.editData = data;
    this.counsellingForm.get('counsellingId').setValue(data?.counsellingId);
    this.counsellingForm.get('counsellorId').setValue(data?.counsellorId);
    this.counsellingForm.get('durationId').setValue(data?.durationId);
    this.counsellingForm.get('date').setValue(data?.date);
    this.counsellingForm.get('endDate').setValue(data?.endDate);
    this.counsellingForm.get('notes').setValue(data?.notes);
    this.counsellingForm.get('performNurse').setValue(data?.performNurse);
    this.counsellingForm.get('performDoc').setValue(data?.performDoc);
    this.isAdd = false;
    this.isEdit = true;
    this.submitButtonTitle = "Update Counselling";
  }

  reset() {
    this.counsellingForm.reset();
    this.isSubmitted = false;
    this.phlen=4000;
    this.phcharflag=false;
    this.counsellingForm.controls['date'].setValue(this.max);  
    if(localStorage.getItem('jobCategoryId')=='2'){
      this.counsellingForm?.get('performNurse')?.setValue(localStorage.getItem('employeeId'));
    }
    if(localStorage.getItem('userFlag')=='Physician'){
      this.counsellingForm?.get('performDoc')?.setValue(localStorage.getItem('physicianId'));
    }
    else{
    this.counsellingForm.get('performDoc').setValue(this.visitDoctorid);  }
  }

  NotesTypevalueChanges(value) {
    if (value != null && value != ''){
      this.phcharflag = true;
      this.phlen = 4000 - value.length;
    }
  }

    performDoc(){
      if(this.performDocList?.length == 0){
       this.rolesService.list(`physicians/${this.tenandId}/${this.branchId}/GetAllInternalDoctor`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.performDocList = data;
       })}else{return}
      
    }
    performNurse(){
      if(this.performNurseList?.length == 0){
      this.rolesService.list(`tenants/${this.tenandId}/${this.branchId}/employee/getEmployeeByCategory?tenantId=${this.tenandId}&branchId=${this.branchId}&jobcategory=2`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.performNurseList = data.details;
      }, (error) => {
      }, () => {
      });}else{return}
      
    }

}
